<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [selectionVisible]="selectEnabled"
    [selectionMultiEnabled]="selectEnabled"
    [interactionMode]="interactionMode"
    [selectableEvaluatorFn]="selectableEvaluatorFn"
    (selectionChange)="selectionChange.emit($event)"
    (itemClick)="selectItem($event)"
  >
    <elder-data-toolbar
      *elderTableToolbar
      (requestRemove)="requestDeleteAll($event)"
      [canMore]="false"
      [canAdd]="false"
      [canRemove]="allowEdit"
    >
      <ng-template elderToolbarContent="main">
        <app-work-item-filter [data]="data" [involvedProcessPlans]="involvedProcessPlans$ | async">
        </app-work-item-filter>
      </ng-template>
    </elder-data-toolbar>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef class="cell-5" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">{{ item.number }}</td>
    </ng-container>

    <!-- state Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef class="cell-10" mat-sort-header>
        {{ 'context.state' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">
        <div class="layout-row place-start-center gap-sm">
          <div>{{ 'WorkItemState.' + item.processingState | translate }}</div>
          @if (showPlanValidationWarning(item)) {
            <div class="flex layout-row place-start-center">
              <mat-icon color="accent" matTooltip="{{ 'validation.messages.no-time' | translate }}"
                >schedule</mat-icon
              >
            </div>
          }
          @if (!WorkItemUtils.bomsAreValid(item)) {
            <div class="flex layout-row place-start-center">
              <mat-icon color="warn" matTooltip="{{ 'positions.parts_list' | translate }}"
                >error</mat-icon
              >
            </div>
          }
        </div>
      </td>
    </ng-container>

    <!-- manufacturing Column -->
    <ng-container matColumnDef="manufacturing">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="productionRoute.productionPath"
        class="cell-15"
      >
        {{ 'manufacturing.title' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">
        <app-item-manufacturing-status style="width: 100%" [item]="item">
        </app-item-manufacturing-status>
      </td>
    </ng-container>

    <!-- work batch id -->
    <ng-container matColumnDef="workBatchId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="workBatchId" class="cell-15">
        {{ 'workBatches.workBatch' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">
        {{ item?.workBatch?.number }}
      </td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell mat-sort-header="description" *matHeaderCellDef class="cell-15">
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">
        <div class="layout-col">
          <span class="text-body-small">{{ item.description }}</span>
          <span>{{ item.orderedProduct?.materialId }}</span>
        </div>
      </td>
    </ng-container>

    <!-- packages Column -->
    <ng-container matColumnDef="packages">
      <th mat-header-cell *matHeaderCellDef>{{ 'packages.packages' | translate }}</th>
      <td mat-cell *matCellDef="let item" class="align-right">
        <app-work-item-packages
          [unitBundles]="item.packages"
          (packageClick)="packageClick($event, item.company)"
        ></app-work-item-packages>
      </td>
    </ng-container>

    <!-- mainProductQuantity Column -->
    <ng-container matColumnDef="mainProductQuantity">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="orderedProduct.quantity"
        arrowPosition="before"
        class="cell-15 align-right"
      >
        {{ 'context.quantity' | translate }}
      </th>
      <td mat-cell *matCellDef="let item" class="align-right">
        @if (isProducedProductDifferent(item)) {
          <div>
            {{ item.producedProduct | productSalesQuantity | elderQuantity }}
            ({{ item.orderedProduct | productSalesQuantity | elderQuantity }})
          </div>
        } @else {
          {{ item.producedProduct | productSalesQuantity | elderQuantity }}
        }
      </td>
    </ng-container>

    <!-- totalWeight Column -->
    <ng-container matColumnDef="totalWeight">
      <th mat-header-cell *matHeaderCellDef class="cell-15 align-right">
        {{ 'context.totalWeight' | translate }}
      </th>
      <td mat-cell *matCellDef="let item" class="align-right">
        @if (isProducedProductDifferent(item)) {
          <div>
            {{ item.producedProduct | productSalesTotalWeight | elderQuantity }}
            ({{ item.orderedProduct | productSalesTotalWeight | elderQuantity }})
          </div>
        } @else {
          {{ item.producedProduct | productSalesTotalWeight | elderQuantity }}
        }
      </td>
    </ng-container>

    <!-- open in terminal -->
    @if (displayTerminalLink) {
      @if (workOrder$ | async; as workOrder) {
        <ng-container matColumnDef="terminal">
          <th mat-header-cell *matHeaderCellDef class="cell-5 align-right">
            {{ 'terminals.terminal' | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let item"
            class="align-right"
            [matTooltip]="getTerminalButtonDisabledMessage(item, workOrder) | translate"
          >
            <button
              mat-icon-button
              elderStopEventPropagation
              [disabled]="!canOpenTerminal(item, workOrder)"
              (click)="openTerminal(item, workOrder)"
            >
              <mat-icon>open_in_browser</mat-icon>
            </button>
          </td>
        </ng-container>
      }
    }

    <!-- actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="cell-5 align-right"></th>
      <td mat-cell *matCellDef="let item" class="align-right">
        <button
          mat-icon-button
          color="primary"
          [matMenuTriggerFor]="itemMenu"
          elderStopEventPropagation
          [disabled]="!canModifyItem(item)"
        >
          <mat-icon>more_vert</mat-icon>
          <mat-menu #itemMenu="matMenu">
            <button mat-menu-item color="primary" (click)="requestDeleteAll([item])">
              <mat-icon>delete</mat-icon>
              {{ 'actions.delete' | translate }}
            </button>
          </mat-menu>
        </button>
      </td>
    </ng-container>
  </elder-table>
</div>
